// extracted by mini-css-extract-plugin
module.exports = {"sizedQtyCell":"VIP_SizedQuantity__sizedQtyCell","sizedQty":"VIP_SizedQuantity__sizedQty"};